/**
 * DevExtreme (esm/__internal/grids/grid_core/keyboard_navigation/dom.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    ATTRIBUTES
} from "./const";
var isDragCell = $cell => void 0 !== $cell.attr(ATTRIBUTES.dragCell);
var getFocusableCellSelector = columnIndex => ["[".concat(ATTRIBUTES.ariaColIndex, '="').concat(columnIndex + 1, '"]'), ":not([".concat(ATTRIBUTES.dragCell, "])"), ":not([aria-hidden=true])"].join("");
var getCellToFocus = ($cellElements, columnIndex) => $cellElements.filter(getFocusableCellSelector(columnIndex)).first();
export var GridCoreKeyboardNavigationDom = {
    isDragCell: isDragCell,
    getCellToFocus: getCellToFocus
};
